/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FirmPlusAdminInfo,
    FirmPlusAdminInfoFromJSON,
    FirmPlusAdminInfoFromJSONTyped,
    FirmPlusAdminInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface FirmPage
 */
export interface FirmPage {
    /**
     * 
     * @type {Array<FirmPlusAdminInfo>}
     * @memberof FirmPage
     */
    items?: Array<FirmPlusAdminInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FirmPage
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof FirmPage
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof FirmPage
     */
    itemsPerPage?: number;
}

export function FirmPageFromJSON(json: any): FirmPage {
    return FirmPageFromJSONTyped(json, false);
}

export function FirmPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(FirmPlusAdminInfoFromJSON)),
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'currentPage': !exists(json, 'currentPage') ? undefined : json['currentPage'],
        'itemsPerPage': !exists(json, 'itemsPerPage') ? undefined : json['itemsPerPage'],
    };
}

export function FirmPageToJSON(value?: FirmPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(FirmPlusAdminInfoToJSON)),
        'totalPages': value.totalPages,
        'currentPage': value.currentPage,
        'itemsPerPage': value.itemsPerPage,
    };
}


